import { match } from 'ts-pattern';
import { FredScale } from '../enums.mjs';
import { formatToDollar } from '../types/utils.mjs';

const MISSING = "No data";
const dollars = (value, options) => formatToDollar(value, options) ?? MISSING;
const GROUPED = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
const GROUPED_1DP = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 });
const formatFredValue = (value, scale) => {
    const unitLabel = FredScale.displayName(scale);
    if (value === null || value === undefined || !Number.isFinite(value)) {
        return { display: MISSING, full: MISSING, unitLabel };
    }
    return match(scale)
        .with(FredScale.Percent, FredScale.NetPercentOfBanks, FredScale.PercentOfBalances, FredScale.PercentOfFirms, () => {
        const rendered = `${GROUPED_1DP.format(value)}%`;
        return { display: rendered, full: rendered, unitLabel };
    })
        .with(FredScale.MillionsOfDollarsSaar, FredScale.MillionsOfDollars, FredScale.MillionsOfChained2017Dollars, () => {
        const amount = value * 1_000_000;
        return {
            display: dollars(amount, { abbreviate: true, round: true }),
            full: dollars(amount, { round: true }),
            unitLabel,
        };
    })
        .with(FredScale.DollarsPerBarrel, FredScale.DollarsPerMetricTon, FredScale.DollarsPerGallon, () => {
        const rendered = dollars(value);
        return { display: rendered, full: rendered, unitLabel };
    })
        .with(FredScale.ThousandsOfPersons, FredScale.ThousandsOfUnitsSaar, () => ({
        display: GROUPED_1DP.format(value),
        full: GROUPED_1DP.format(value),
        unitLabel,
    }))
        .with(FredScale.Units, FredScale.Count, () => ({
        display: GROUPED.format(value),
        full: GROUPED.format(value),
        unitLabel,
    }))
        .with(FredScale.Index, () => ({
        display: GROUPED_1DP.format(value),
        full: GROUPED_1DP.format(value),
        unitLabel,
    }))
        .exhaustive();
};

export { formatFredValue };
